import { gql } from '@apollo/client'

export default gql`
  query GetGameBattlePassSchedules($userId: String) {
    getGameBattlePassSchedules(userID: $userId) {
      startAt
      endAt
      battlePassType
      currentEXP
      displayName
      maximumLevel
      scheduleID
      fortuneKeys
      seasonID
    }
  }
`
